/* tslint:disable:no-any */
import { KnownError } from './known.error';

/**
 * Error to be emitted for empty OAuth token refresh error responses.
 */
export class OAuthTokenRefreshError extends KnownError<any> {
  public readonly name: string = 'OAuthTokenRefreshError';
}
